import type {Metadata} from 'next'
import {inject, injectable} from 'inversify'

import {DI} from '@/src/config/di/types'
import {Routes} from '@/src/config/routes'
import type {LoadPageDataParams} from '@/src/core/domain/page'
import type {IApiClientServiceFactory} from '@/src/ports/services/api'

type LightPageMeta = Pick<PageMeta, 'title' | 'description' | 'keywords' | 'alternates'> & {
  og?: Metadata['openGraph']
}

@injectable()
export class GetPageMetaUseCase {
  @inject(DI.IApiClientServiceFactory)
  apiClientFactory!: IApiClientServiceFactory

  async do(pageOptions: LoadPageDataParams): Promise<Metadata> {
    const client = this.apiClientFactory('web-api')

    const meta = await client.post<LightPageMeta>(Routes.webApi.page.meta, {
      data: {
        type: pageOptions.type,
        params: pageOptions.params,
        searchParams: pageOptions.searchParams,
      },
    })

    return {
      title: meta.title,
      description: meta.description,
      keywords: meta.keywords,
      alternates: meta.alternates,
      openGraph: meta.og,
    }
  }
}
